import React, { useMemo, useState } from 'react';
import './loginInput.scss';
import { Input } from '@douyinfe/semi-ui';
import { LoginInputProps } from './types';

const LoginInput = ({
  status,
  mode,
  icon,
  suffix,
  placeholder,
  changeData,
  enterEvent,
  defaultValue = '', // 新增默认值参数
}: LoginInputProps) => {
  const [inputValue, setInputValue] = useState(defaultValue);
  const [isActive, setIsActive] = useState(!!defaultValue);
  const [isFocused, setIsFocused] = useState(false);

  function inputFocus() {
    // 点击激活
    setIsActive(true);
    setIsFocused(true);
  }
  // 输入框失去焦点
  function inputBlur() {
    setIsFocused(false);
    // 如果没有值就取消激活
    if (!inputValue) {
      setIsActive(false);
    }
  }
  // 赋值
  function inputChange(value: string) {
    setInputValue(value);
    changeData && changeData(value);
  }
  // 获取 box 样式
  const boxClass = useMemo(() => {
    const classes = [
      'login-input',
      'flex',
      'flex-row',
      `login-input-status-${status}`,
    ];

    if (isActive) {
      classes.push('login-input-active');
    }

    if (isFocused) {
      classes.push('login-input-focused');
    }

    return classes.join(' ');
  }, [isActive, isFocused, status]);

  return (
    <div className={boxClass}>
      <div
        className={'login-input-icon flex flex-row items-center justify-center'}
      >
        {icon}
      </div>
      <div className={'login-input-box'}>
        <Input
          mode={mode}
          className={'login-semi-input'}
          onEnterPress={enterEvent}
          onChange={inputChange}
          onFocus={inputFocus}
          onBlur={inputBlur}
          value={inputValue} // 添加这行以显示默认值
          placeholder={placeholder}
        />
      </div>
      {suffix && (
        <div
          className={
            'login-input-status flex flex-row items-center justify-center'
          }
        >
          {suffix}
        </div>
      )}
    </div>
  );
};

export default LoginInput;
